<template>
  <div>
    <div class="h1">
      <img src="../../assets/img/pagess/gdd103/1_01.png" alt="">
    </div>
    <div class="h2">
      <div class="h2s">
        <img @click="to_xaizai()" src="../../assets/img/pagess/gdd103/btn.gif" alt="">
      </div>
    </div>
    <div class="h3" ref="obtain">
      <img src="../../assets/img/pagess/gdd103/1_03.png" alt="">
    </div>
    <div class="h4">
      <div class="h4s">
        <img src="../../assets/img/pagess/gdd103/compass.gif" alt="">
      </div>
    </div>
    <div class="h5">
      <div class="h5s1">
        <img @click="to_xaizai()" src="../../assets/img/pagess/gdd103/download.gif" alt="">
        <div class="input">
          <input type="text" placeholder="请输入代码/名称,获取全面诊断" @keyup.enter="to_xaizai()" v-model="message">
        </div>

      </div>

      <div class="h5s2">
        <div class="lis1">
          <div v-for="(item,index) in btns" :key="index">
            <div :class=" active==index?'btn1':'btn2'" @click="changebar(index)">
              <div class="text1">{{item.text1}}</div>
              <div class="text2">{{item.text2}}</div>
            </div>
          </div>
        </div>
        <div class="lis2">
          <div v-for="(item,index) in imgs" :key="index">
            <!-- :src='../../assets/img/pagess/gdd103/.png" alt="" -->
            <img v-if="active==index" :src="require(`../../assets/img/pagess/gdd103/${item.icon}`)">
          </div>
        </div>
      </div>

    </div>
    <div class="bottomsss">

      <p>————&nbsp;投资有风险入市需谨慎&nbsp;————</p>
      <p>从事证券投资或期货交易，请通过合法证券期货经营机构进行&nbsp;&nbsp;&nbsp; 合法机构名单可到中国证监会网站 (<a
          href="http://www.csrc.gov.cn/">www.csrc.gov.cn</a>)查询
      </p>
      <p>北京天相财富管理顾问有限公司河北分公司 &nbsp;&nbsp;&nbsp; <a
          href="https://beian.miit.gov.cn/">冀ICP备2021023389号-1</a>&nbsp;&nbsp;&nbsp;
        执证编号：91110102MA001GJE1N</p>
      <p>天相股多多软件版本号：v1.3.1.1288 更新时间：2022年5月</p>
      <p style=" 
    text-decoration: underline;cursor:pointer;" class="qwer">
        <!-- 联系电话:010-********&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
        <span @click="open_yinsi()" style="margin-right:10px">隐私保护政策</span>
        <span @click="open_fuwuxieyi()">软件服务协议</span>
      </p>
      <p>开发者名称:北京天相财富管理顾问有限公司</p>
    </div>
    <div class="box"></div>
    <div class="bar" v-if="res">
      <div class="w">
        <img @click="to_xaizai()" class="btn2" src="../../assets/img/pagess/gdd103/btn2.gif" alt="">
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      res: false,
      message: "",
      btns: [
        {
          text1: "看大盘",
          text2: "一键知指数趋势",
        },
        {
          text1: "抓热点",
          text2: "秒速捕获异动板块",
        },
        {
          text1: "定策略",
          text2: "一键选股:多种选股思路",
        },
        {
          text1: "跟游资",
          text2: "量化龙虎榜行为数据",
        },
        {
          text1: "牛人圈",
          text2: "学龙头实战技巧",
        },
      ],
      imgs: [
        {
          icon: "1.png",
          name: "1111111",
        },
        {
          icon: "2.png",
          name: "22222",
        },
        {
          icon: "3.png",
          name: "22222",
        },
        {
          icon: "4.png",
          name: "22222",
        },
        {
          icon: "5.png",
          name: "22222",
        },
      ],
      active: 0,
    };
  },
  mounted() {
    // 滚动条的获取
    window.addEventListener("scroll", this.handleScrollx, true);

     this.clientIp();
  },
  methods: {
    open_yinsi() {
      window.open("https://ins.juniubang.com/images/隐私政策4.7.pdf");
    },
    open_fuwuxieyi() {
      window.open("https://ins.juniubang.com/images/应用权限4.7.pdf");
    },
    changebar(index) {
      this.active = index;
    },
    to_xaizai() {
      window.open("https://cdn.juniubang.com/apk/GDD1002.exe");
      // this.clientIp();
      this.post_leilei_data();
      this.message = "";
      // this.post_data();
    },
    post_leilei_data() {
      this.$http
        .post("/to_exe", {
          url: window.location.href,
          qhclickid: this.$route.query.bd_vid,
          code: this.$route.query.code,
          type: "baidu2",
        })
        .then((res) => {
           
        });
    },

    handleScrollx() {
      if (this.$refs.obtain.getBoundingClientRect().top < 890) {
        this.res = true;
      } else {
        this.res = false;
      }
        
    },
    clientIp() {
      this.$http
        .post("/client_ip", { url: window.location.href })
        .then((res) => {
          window.localStorage.setItem("_number", res.data);
        });
    },
    // post_data() {
    //   this.$http
    //     .post("/to_api", {
    //       qhclickid: this.$route.query.qhclickid,
    //       trans_id: this.$route.query.qhclickid,
    //     })
    //     .then((res) => {
    //        
    //     });
    // },
  },
};
</script>

<style lang="less" scoped>
.bottomsss {
  width: 100%;
  height: 130px;
  background-color: #6f090f;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #fff;
  .qwer span:hover {
    // color: rgb(248, 134, 134);
    color: blue;
  }
  a {
    font-size: 12px;
    color: #fff;
    text-decoration: underline;
  }
  p {
    margin: 0;
    font-size: 12px;
  }
}
.box {
  width: 100%;
  height: 200px;
  background-color: #6f090f;
}
* {
  user-select: none;
}
.h1 {
  font-size: 0;
}
.h2 {
  font-size: 0;
  width: 100%;
  height: 536px;
  background: url(../../assets/img/pagess/gdd103/1_02.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .h2s {
    font-size: 0;
    padding-top: 102px;
  }
}
.h3 {
  font-size: 0;
}
.h4 {
  width: 100%;
  height: 537px;
  background: url(../../assets/img/pagess/gdd103/1_04.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .h4s {
    padding-top: 40px;
    z-index: 998;
  }
}
.h5 {
  width: 100%;
  height: 1322px;
  background: url(../../assets/img/pagess/gdd103/1_05.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .h5s1 {
    padding-top: 100px;
    z-index: 998;
    width: 952px;
    height: 133px;
    position: relative;
    .input {
      position: absolute;
      background-color: green;
      z-index: 999;
      top: 120px;
      left: 180px;
      input {
        font-size: 30px;
        width: 480px;
        height: 80px;
        outline: none;
        border: none;
      }
    }
  }
  .h5s2 {
    margin: 260px;
    width: 1203px;
    height: 813px;
    background: url(../../assets/img/pagess/gdd103/bg.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .lis1 {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn1 {
        cursor: pointer;
        margin: 0 10px;
        width: 205px;
        height: 64px;
        background: url(../../assets/img/pagess/gdd103/red.png) no-repeat;
        background-size: 100% 100%;
        text-align: center;
        .text1 {
          font-size: 25px;
          color: #fefeff;
          font-weight: 600;
          padding-top: 5px;
        }
        .text2 {
          font-size: 16px;
          color: #f9b03e;
        }
      }
      .btn2 {
        cursor: pointer;
        margin: 0 10px;
        width: 205px;
        height: 64px;
        background: url(../../assets/img/pagess/gdd103/black.png) no-repeat;
        background-size: 100% 100%;
        text-align: center;
        .text1 {
          font-size: 25px;
          color: #fefeff;
          font-weight: 600;
          padding-top: 5px;
        }
        .text2 {
          font-size: 16px;
          color: #fefeff;
        }
      }
    }
    .lis2 {
      margin-top: 54px;
    }
  }
}
.bar {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 159px;
  background: url(../../assets/img/pagess/gdd103/bar.png) no-repeat;
  background-size: 100% 100%;
  z-index: 999;
  .w {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    padding-top: 45px;
    justify-content: flex-end;
    img {
      width: 316px;
      height: 96px;
    }
  }
}
img {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/pagess/gdd105.vue